export enum DrawingModeEnum {
  CIRCLE = 'draw_circle',
  POLYGON = 'draw_polygon',
  DIRECT_SELECT = 'direct_select',
  SIMPLE_SELECT = 'simple_select',
  CUT_LINE = 'cut_line',
  DRAW_LINE_STRING = 'draw_line_string',
}
